import { render, staticRenderFns } from "./SendAlertsTable.vue?vue&type=template&id=3931dc96&"
import script from "./SendAlertsTable.vue?vue&type=script&lang=js&"
export * from "./SendAlertsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports